export const MACOS_VERSION_ERROR = "Use macOS version El Capitan or newer to edit variables in your settings."

export default () => {
  const userAgent = /AppleWebKit\/(.{3})/.exec(navigator.userAgent)
  const majorVersion = userAgent === null ?
    null :
    parseInt(userAgent[1])
  return majorVersion < 601 && navigator.vendor === 'Apple Computer, Inc.'
}



// WEBPACK FOOTER //
// ./src/components/Settings/check-user-agent.js